"use client";

import { useLayoutEffect, useRef } from "react";
import { useSession } from "next-auth/react";
import { redirectTo, REDIRECT_MESSAGES } from "@/libs/redirectLoading";

export const POST_AUTH_REDIRECT_KEY = "peeqd_post_auth_redirect";

export function setPostAuthRedirect(target: string): void {
  try {
    sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, target);
  } catch {
    // Non-critical.
  }
}

export function clearPostAuthRedirect(): void {
  try {
    sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
  } catch {
    // Non-critical.
  }
}

export function getPostAuthRedirect(): string | null {
  try {
    return sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
  } catch {
    return null;
  }
}

/**
 * When auth completes (Google popup or email return), redirect immediately with
 * the sitewide overlay before dashboard UI can flash underneath.
 */
export default function PostAuthRedirectGuard(): null {
  const { status } = useSession();
  const handledRef = useRef(false);

  useLayoutEffect(() => {
    if (status !== "authenticated") {
      handledRef.current = false;
      return;
    }

    const target = getPostAuthRedirect();
    if (!target || handledRef.current) return;

    handledRef.current = true;
    clearPostAuthRedirect();

    const message =
      target === "/pricing"
        ? REDIRECT_MESSAGES.pricing
        : REDIRECT_MESSAGES.redirecting;
    redirectTo(target, message);
  }, [status]);

  return null;
}
